import { type ReactElement, type ReactNode } from 'react';

import { Box, Stack, styled } from '@mui/material';

const Wrapper = styled(Box)(({ theme }) => ({
  width: 64,
  height: '100vh',
  paddingTop: 24,
  backgroundColor: theme.palette.horizonBlue2.main,
  zIndex: 20,
}));

export type MainMenuContainerProps = {
  children: ReactNode;
};

export const MainMenuContainer = (
  props: MainMenuContainerProps,
): ReactElement => {
  return (
    <Wrapper component="aside">
      <Stack component="nav" spacing={3}>
        {props.children}
      </Stack>
    </Wrapper>
  );
};
